import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { filterDailyStatisticsBasedOnCategory } from '../../redux/systemInfos/selectors';
import DailyStatistics from '../../components/DailyStatistics/dailyStatistics';
import { withRouter } from "react-router";

function DailyStatisticsPage(props) {

  function filterDailyStatistics(statisticCategory, orderByCatecgory, sortingOrder, startDate, endDate) {
    return props.filterDailyStatistics(statisticCategory, orderByCatecgory, sortingOrder, startDate, endDate)
  }

  function handleRowOnClick(record) {
    props.history.push(`/Dashboard/clinicDetails/${record.id}`)
  }

  return (
    <Row>
      <Col>
        <DailyStatistics
          filterDailyStatistics={filterDailyStatistics}
          handleRowOnClick={handleRowOnClick} />
      </Col>
    </Row>
  )
}

DailyStatisticsPage.propTypes = {
  filterDailyStatistics: PropTypes.func.isRequired,
};

DailyStatisticsPage.defaultProps = {
}

const mapActionsToProps = {
};

function mapStateToProps(state) {
  return {
    filterDailyStatistics: (statisticCategory, orderByCatecgory, sortingOrder, startDate, endDate) => filterDailyStatisticsBasedOnCategory(state, statisticCategory, orderByCatecgory, sortingOrder, startDate, endDate),
  };
}

const wrappedDailyStatisticsPage = withRouter(DailyStatisticsPage);
const connectedDailyStatisticsPage = connect(mapStateToProps, mapActionsToProps)(wrappedDailyStatisticsPage);
export default connectedDailyStatisticsPage;